
import Icon, { iconColor, iconTypes } from "../../common/components/Icon.jsx";

import DropDownList from "../../common/components/DropDownList.jsx";
import LabelField from "../../common/components/LabelField.jsx";
import {Localization} from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = () => {
    return (state) => ({
        singleChainSortiment: state.singleChainSortiment,
        singleEpixSortiment: state.singleEpixSortiment,
        multiChainSortiment: state.multiChainSortiment,
        multiEpixSortiment: state.multiEpixSortiment,
    });
};
const mapDispatchToProps = {
};

/**
 * Creates a compunents, with tools the change the filter
 * @param {props} object
 * @returns {node}
 */
function ChainFilterComponent({singleChainSortiment, singleEpixSortiment, multiChainSortiment,  multiEpixSortiment, localization, onEdit, setDropDown, useSingleEpix, useMultiChain, useMultiEpix}) {

    /**
     * Clears the filter
     * @returns {*}
     */
    function onClickClearFilter() {
        onEdit({
            productStatus: null,
            invoiceGroupId: null,
            productGroupId: null,
            supplierId: null,
        });
    }

    const chainSort = useSingleEpix ? singleEpixSortiment : useMultiChain ? multiChainSortiment : useMultiEpix ?  multiEpixSortiment : singleChainSortiment;

    const prdGroupOptions = [
        {
            value: undefined,
            label: localization.text("order", "all"),
        },
        ...(chainSort && chainSort.productGroups && chainSort.productGroups.map((item) => {
            return {
                value: item.productGroupId,
                label: item.productGroupName,
            };
        }) || []),
    ];
    const supplierGroupOptions = [
        {
            value: undefined,
            label: localization.text("order", "all"),
        },
        ...(chainSort && chainSort.productSuppliers && chainSort.productSuppliers.map((item) => {
            return {
                value: item.supplierId,
                label: item.supplierName,
            };
        }) || []),
    ];
    const invoiceGroupsOptions = [
        {
            value: undefined,
            label: localization.text("order", "all"),
        },
        ...(chainSort && chainSort.invoiceGroups && chainSort.invoiceGroups.map((item) => {
            return {
                value: item.invoiceCode,
                label: item.description,
            };
        }) || []),
    ];
    const statusOptions = [
        {value: 0, label: localization.text("order", "all")},
        {value: 1, label: "Aktiv" },
        {value: 2, label: "Erstattes ved utsolgt" },
        {value: 4, label: "Innkommende" },
        {value: 5, label: "Erstattet" },
        {value: 6, label: "Ikke aktiv ved utsolgt" },
    ];

    const isFilterSelected = chainSort.chainFilter.productGroupId != null || chainSort.chainFilter.supplierId != null || chainSort.chainFilter.productStatus != null || singleChainSortiment.chainFilter.invoiceGroupId != null;

    return (
        <div className="filter-spacing">
            <div className="filter-label">
                <LabelField label={localization.text("filter","productStatus")} />
            </div>
            <DropDownList options={statusOptions} placeholder="Alle" onEdit={onEdit} source={chainSort.chainFilter} property={"productStatus"} setDropDown={setDropDown}/>
            <div className="filter-label">
                <LabelField label={localization.text("filter","invoiceGroup")} />
            </div>
            <DropDownList options={invoiceGroupsOptions} placeholder="alle" onEdit={onEdit} source={chainSort.chainFilter} property={"invoiceGroupId"} setDropDown={setDropDown}/>
            <div className="filter-label">
                <LabelField label={localization.text("filter","productGroup")} />
            </div>
            <DropDownList options={prdGroupOptions} placeholder="alle" onEdit={onEdit} source={chainSort.chainFilter} property={"productGroupId"} setDropDown={setDropDown}/>
            <div className="filter-label">
                <LabelField label={localization.text("filter","supplierName")} />
            </div>
            <DropDownList options={supplierGroupOptions} placeholder="alle" onEdit={onEdit} source={chainSort.chainFilter} property={"supplierId"} setDropDown={setDropDown}/>
            {isFilterSelected && (
                <div className="filter-button">
                    <button className="btn primary icon" onClick={onClickClearFilter}><Icon type={iconTypes.x} color={iconColor.red} />Clear filter</button>
                </div>
            )}
        </div>
    );
}

ChainFilterComponent.propTypes = {
    localization: Localization.propTypes.isRequired,
    singleChainSortiment: PropTypes.object.isRequired,
    singleEpixSortiment: PropTypes.object.isRequired,
    multiChainSortiment: PropTypes.object.isRequired,
    multiEpixSortiment: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    useSingleEpix: PropTypes.bool.isRequired,
    useMultiChain: PropTypes.bool.isRequired,
    useMultiEpix: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps,mapDispatchToProps)(ChainFilterComponent);